import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';

import { ReportsRoutingModule } from './reports-routing.module';
import { EmployeeReportComponent } from './employee-report/employee-report.component';
import { SharedModule } from 'src/app/shared/shared.module';

import { SelectButtonModule } from 'primeng/selectbutton';
import { DropdownModule } from 'primeng/dropdown';
import { AccordionModule } from 'primeng/accordion';
import { ChartModule } from 'primeng/chart';
import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { StepsModule } from 'primeng/steps';



import { NotasFiscaisReportComponent } from './notas-fiscais-report/notas-fiscais-report.component';
import { EmployeeReportDialogComponent } from './employee-report-dialog/employee-report-dialog.component';
import { FinantialReportComponent } from './finantial-report/finantial-report.component';
import { ProfessionalTransfersReportComponent } from './professional-transfers-report/professional-transfers-report.component';
import { ProfessionalTransfersModalComponent } from './professional-transfers-modal/professional-transfers-modal.component';
import { SplitIconComponent } from 'src/app/shared/components/split-icon/split-icon.component';
import { ServiceReportComponent } from './service-report/service-report.component';
import { ProgressBar, ProgressBarModule } from 'primeng/progressbar';
import { ServiceReportFilterMenuComponent } from './service-report-filter-menu/service-report-filter-menu.component';
import { FinantialExpensesReportComponent } from './finantial-expenses-report/finantial-expenses-report.component';
import { FinantialReceiptsReportComponent } from './finantial-receipts-report/finantial-receipts-report.component';
import { SearchExpensesComponent } from './search-expenses/search-expenses.component';
import { SearchReceiptsComponent } from './search-receipts/search-receipts.component';
import { BankingReportComponent } from './banking-report/banking-report.component';
import { WithdrawalModalComponent } from './withdraw-modal/withdrawal-modal.component';


@NgModule({
  declarations: [
    EmployeeReportComponent,
    NotasFiscaisReportComponent,
    EmployeeReportDialogComponent,
    ProfessionalTransfersReportComponent,
    ProfessionalTransfersModalComponent,
    FinantialReportComponent,
    ServiceReportComponent,
    ServiceReportFilterMenuComponent,
    FinantialExpensesReportComponent,
    FinantialReceiptsReportComponent,
    SearchExpensesComponent,
    SearchReceiptsComponent,
    BankingReportComponent,
    BankingReportComponent,
    WithdrawalModalComponent
  ],
  imports: [
    CommonModule,
    ReportsRoutingModule,
    SharedModule,
    SelectButtonModule,
    DropdownModule,
    AccordionModule,
    ChartModule,
    MenuModule,
    ButtonModule,
    ProgressBarModule,
    StepsModule
  ],
  providers: [DatePipe, CurrencyPipe]
})
export class ReportsModule { }
